import React from "react";
import { Button } from "antd";

const EmptyState = ({ message = "Nothing here yet", actionLabel, onAction }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "36px 16px",
        textAlign: "center",
        gap: 12,
      }}
    >
      <svg width="88" height="72" viewBox="0 0 88 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10" y="16" width="68" height="48" rx="8" fill="var(--i-ems-primary-light)" />
        <rect x="20" y="28" width="48" height="6" rx="3" fill="#C7D2FE" />
        <rect x="20" y="40" width="32" height="6" rx="3" fill="#C7D2FE" />
        <circle cx="64" cy="14" r="12" fill="#EEF2FF" stroke="var(--i-ems-primary)" strokeWidth="2" />
        <path d="M59 14l3.5 3.5L69 10.5" stroke="var(--i-ems-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div style={{ color: "var(--i-ems-text-secondary)", fontSize: 14 }}>{message}</div>
      {actionLabel && onAction && (
        <Button type="primary" size="small" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
